var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-white"},[_c('Header',{attrs:{"leftHandler":_vm.back}}),_c('ReturnToLogin',{ref:"ReturnToLogin",on:{"after-confirm":_vm.handleJumpHome}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }